export enum CronJobStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum HTTPMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface CronJob {
  status: CronJobStatus;
  id: string;
  name: string;
  cronExpression: string;
  command: any;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface HTTPCronJobCommand {
  command: 'HTTP';
  header: Record<string, string>;
  argument: {
    method: HTTPMethod;
    url: string;
    body: any;
  };
}

export interface HTTPCronJob extends Omit<CronJob, 'command'> {
  command: HTTPCronJobCommand;
}

// For API requests
export interface CreateCronJobRequest {
  name: string;
  cronExpression: string;
  command: HTTPCronJobCommand;
  status?: CronJobStatus;
}

export interface UpdateCronJobRequest {
  name?: string;
  cronExpression?: string;
  command?: HTTPCronJobCommand;
  status?: CronJobStatus;
}
